// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"Modal_modalTitle__BrJuw","modalContent":"Modal_modalContent__1rYYD","modalFooter":"Modal_modalFooter__2dKHi"};